import React, { useSyncExternalStore } from 'react';
import { DSAlert, DSButton, DSIcon } from '../design-system/primitives';
import {
  getConnectionStatus,
  subscribeConnectionStatus,
  dismissRecovered,
  formatSavedAt
} from '../services/connectionStatus';
import './ConnectionBanner.css';

/**
 * Says so when what the app is showing is not live.
 *
 * Without this, a member whose browser had kept a copy of the app saw it load
 * and render normally while the server was off, and only found out when saving
 * something failed. The state comes from services/connectionStatus.js.
 */

export function connectionMessage(status) {
  if (status.reachable) {
    if (!status.recovered) return null;
    return {
      variant: 'success',
      title: 'Back online.',
      detail: 'Refresh to see the latest.'
    };
  }

  const savedAt = status.savedAt ? formatSavedAt(status.savedAt) : null;
  const saved = savedAt ? `Showing saved results from ${savedAt}. ` : '';

  if (status.deviceOffline) {
    return {
      variant: 'warning',
      title: "You're offline.",
      detail: `${saved}Changes won't be saved until you reconnect.`
    };
  }
  return {
    variant: 'warning',
    title: "Can't reach the Capital Pinball Club server.",
    detail: `${saved}Changes won't be saved until it's back.`
  };
}

function ConnectionBanner() {
  const status = useSyncExternalStore(subscribeConnectionStatus, getConnectionStatus);
  const message = connectionMessage(status);
  if (!message) return null;

  return (
    <div className="connection-banner">
      <DSAlert variant={message.variant}>
        <div className="connection-banner__body">
          <DSIcon name={message.variant === 'success' ? 'checkCircle' : 'warning'} />
          <p className="connection-banner__text">
            <strong>{message.title}</strong> {message.detail}
          </p>
          {status.recovered && (
            <div className="connection-banner__actions">
              <DSButton size="sm" onClick={() => window.location.reload()}>
                Refresh
              </DSButton>
              <DSButton size="sm" variant="ghost" onClick={dismissRecovered}>
                Dismiss
              </DSButton>
            </div>
          )}
        </div>
      </DSAlert>
    </div>
  );
}

export default ConnectionBanner;
